<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <loader-dialog :showLoader="loading" message="Carregando..." />
    <v-card>
      <v-card-title class="docgo white--text title">
        <v-icon class="pr-4" color="white">
          mdi-briefcase-account-outline
        </v-icon>
        <span>
          {{ dialogTitle }}
        </span>
      </v-card-title>

      <v-form ref="administrativeUnitForm" class="pa-4" v-model="administrativeUnitForm" lazy-validation>
        <v-layout>
          <v-flex>
            <span class="subheading font-weight-bold grey--text text--darken-1">Informações</span>
            <v-layout>
              <v-flex xs5>
                <v-text-field label="Nome" persistent-hint v-model="administrativeUnit.name"
                  :rules="[validationRules.required]" />
              </v-flex>
              <v-spacer />
              <v-flex xs6>
                <v-text-field label="Sigla" persistent-hint v-model="administrativeUnit.abbreviation"
                  :rules="[validationRules.required, validationRules.onlyLetters]" />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-autocomplete label="Setor atrelado" v-model="administrativeUnit.administrative_unit"
                  :loading="administrativeUnits.length === 0" :items="administrativeUnits" item-text="name" return-object
                  no-data-text="Nenhum resultado encontrado" />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
      <v-card-actions class="px-4 pb-4">
        <v-btn flat :loading="isSaving" @click="closeDialog()">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="saveUpdateAdministrativeUnit()" :loading="isSaving"
          :disabled="!administrativeUnitForm">
          <v-icon class="pr-2">
            mdi-content-save
          </v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LoaderDialog from '@/components/LoaderDialog';
import validationRules from '@/mixins/validation-rules';
import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';

export default {
  components: {
    LoaderDialog,
  },
  name: "administrative-unit-form",
  props: ['dialog'],
  data() {
    return {
      administrativeUnit: {
        administrative_unit: {},
      },
      administrativeUnits: [],
      loading: false,
      administrativeUnitForm: true,
      isSaving: false,
      validationRules: {
        required: value => !!value || 'Campo obrigatório.',
        onlyLetters: value => /^[A-Za-z]+$/.test(value) || 'Apenas letras são permitidas, sem acentos ou espaços.'
      },
    };
  },
  computed: {
    selectedAdministrativeUnit() {
      return this.$store.getters.administrativeUnit;
    },
    dialogTitle() {
      return (this.administrativeUnit && this.administrativeUnit.id) ? 'Editar Setor' : 'Novo Setor';
    },
  },
  mounted() {
    this.loadAdministrativeUnits();

    this.administrativeUnit = Object.assign({}, this.selectedAdministrativeUnit);

    if (this.administrativeUnit.id)
      this.validateForms();
    else
      this.resetForms();
  },
  methods: {
    closeDialog() {
      this.$emit('update:dialog', false);
      this.resetForms();
    },
    loadAdministrativeUnits() {
      this.loading = true
      AdministrativeUnitService.all({ all: true })
        .then(({ data }) => this.administrativeUnits = data).finally(() => this.loading = false);
    },
    resetForms() {
      this.$refs.administrativeUnitForm.resetValidation();
    },
    validateForms() {
      this.$refs.administrativeUnitForm.validate();
    },
    saveUpdateAdministrativeUnit() {
      this.validateForms();
      if (this.$refs.administrativeUnitForm.validate()) {
        const formData = new FormData();
        formData.append('name', this.administrativeUnit.name);
        formData.append('administrative_unit_id', this.administrativeUnit.administrative_unit ? this.administrativeUnit.administrative_unit.id : undefined);
        formData.append('abbreviation', this.administrativeUnit.abbreviation);

        this.isSaving = true;
        if (this.administrativeUnit.id) {
          AdministrativeUnitService.update(formData, this.administrativeUnit.id)
            .then(() => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'success',
                message: 'Setor atualizado com sucesso!',
                messageIcon: 'mdi-check',
              });
              this.closeDialog();
              this.$emit('updateList');
            }).catch((request) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'error',
                message: request.response.data.toString(),
                messageIcon: 'mdi-check',
              });
            }).finally(() => {
              this.isSaving = false;
            });
        } else {
          AdministrativeUnitService.create(formData)
            .then(({ data }) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'success',
                message: 'Setor criado com sucesso!',
                messageIcon: 'mdi-check',
              });
              this.closeDialog();
              this.$emit('updateList');
            }).catch((request) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'error',
                message: request.response.data.toString(),
                messageIcon: 'mdi-check',
              });
            }).finally(() => {
              this.isSaving = false;
            });
        }
      }
    },
  },
  watch: {
    'administrativeUnit.abbreviation': function (newVal) {
      this.administrativeUnit.abbreviation = newVal.toUpperCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/administrative_unit/AdministrativeUnitForm.vue